module.exports = __webpack_public_path__ + "static/img/config_general.2095909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/config_general.jpg
// module id = L3z+
// module chunks = 1